export default "__VITE_ASSET__CuPXl4c4__"